import React, { Component } from "react";
import { connect } from "react-redux";
import {
  retrieveChantiers,
  findChantiersByTitle,
  deleteAllChantiers,
} from "../actions/chantier";
import { Link } from "react-router-dom";

class ChantiersList extends Component {
  constructor(props) {
    super(props);
    this.onChangeSearchNom = this.onChangeSearchNom.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.setActiveChantier = this.setActiveChantier.bind(this);
    this.findByNom = this.findByNom.bind(this);
    this.removeAllChantiers = this.removeAllChantiers.bind(this);

    this.state = {
      currentChantier: null,
      currentIndex: -1,
      searchNom: "",
    };
  }

  componentDidMount() {
    this.props.retrieveChantiers();

  }

  onChangeSearchNom(e) {
    const searchNom = e.target.value;

    this.setState({
      searchNom: searchNom,
    });
  }

  refreshData() {
    this.setState({
      currentChantier: null,
      currentIndex: -1,
    });
  }

  setActiveChantier(chantier, index) {
    this.setState({
      currentChantier: chantier,
      currentIndex: index,
    });
  }

  removeAllChantiers() {
    this.props
      .deleteAllChantiers()
      .then((response) => {
        console.log(response);
        this.refreshData();
      })
      .catch((e) => {
        console.log(e);
      });
  }

  findByNom() {
    this.refreshData();

    this.props.findChantiersByTitle(this.state.searchNom);
  }

  render() {
    const { searchNom, currentChantier, currentIndex } = this.state;
    const { chantiers } = this.props;


    return (
      <div className="list row">
        <div className="col-md-8">
          <div className="input-group mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Rechercher un chantier"
              value={searchNom}
              onChange={this.onChangeSearchNom}
            />

            <div className="input-group-append">
              <button
                className="btn btn-outline-secondary"
                type="button"
                onClick={this.findByNom}
              >
                Rechercher
              </button>

            </div>

          </div>
        </div>
        <div className="col-md-6">
          <h4>Liste des chantiers</h4>

          <ul className="list-group">

            {chantiers &&
            chantiers.map((chantier, index) => (

                  <li
                  className={
                    "list-group-item " +
                    (index === currentIndex ? "active" : "")
                  }

                  onClick={() => this.setActiveChantier(chantier)}
                  key={chantier.id}

                >
                    <ul> {chantier.Nom}   {chantier.Numero_chantier}     </ul>
                </li>


              ))}
          </ul>

          <button
            className="m-3 btn btn-sm btn-danger"
            onClick={this.removeAllChantiers}
          >
            Supprimer tous les chantiers
          </button>
        </div>
        <div className="col-md-6">
          {currentChantier ? (
            <div>
              <h4>Chantier</h4>
              <div>
                <label>
                  <strong>Nom:</strong>
                </label>{" "}
                {currentChantier.Nom}
              </div>
              <div>
                <label>
                  <strong>Status:</strong>
                </label>{" "}
                {currentChantier.published ? "Published" : "Pending"}
              </div>

              <Link
                to={"/chantiers/" + currentChantier.id}
                className="badge badge-warning"
              >
                Editer
              </Link>
            </div>
          ) : (
            <div>
              <br />
              <p>Cliquez sur un chantier ou  </p>
              <p>  <a className="nav-item"
                            href="https://pointage.ansart-tp.com/addchantiers" type="button"> Ajouter un chantier </a>
              </p>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    chantiers: state.chantiers,
  };
};

export default connect(mapStateToProps, {
  retrieveChantiers,
  findChantiersByTitle,
  deleteAllChantiers,
})(ChantiersList);
